import { useState } from "react";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useLocation } from "react-router-dom";
import { makeRequest } from "../../../utils/axios.js"; 

export const useFriends = () => {
    const queryClient = useQueryClient();

    const userId = parseInt(useLocation().pathname.split("/")[2]);

    const [showModal, setShowModal] = useState(false);
    const [userIdToDelete, setUserIdToDelete] = useState(null);

    const { isLoading, error, data } = useQuery({
        queryKey: ["friends", userId],
        queryFn: () => makeRequest.get("/friendships/friends?userId=" + userId).then((res) => res.data),
    });

    const deleteMutation = useMutation({
        mutationFn: (id) => makeRequest.delete("/friendships?userId=" + id),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["friends"] });
        },
    });

    const handleUnfriendClick = (e, friendId) => {
        e.preventDefault();
        e.stopPropagation();
        setUserIdToDelete(friendId);
        setShowModal(true);
    };

    const confirmDelete = () => {
        if (userIdToDelete) {
            deleteMutation.mutate(userIdToDelete);
        }
        setShowModal(false);
        setUserIdToDelete(null);
    };

    const cancelDelete = () => {
        setShowModal(false);
        setUserIdToDelete(null);
    };

    return {
        friends: data,
        isLoading,
        error,
        modalState: {
            isOpen: showModal,
            confirm: confirmDelete,
            cancel: cancelDelete
        },
        handleUnfriendClick
    };
};